<template>
    <div>
        <member-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :paginationData="filterSet.page"
                            :countryOptions="countryOptions" :langData="langData"></member-filter-link>
        <member-list-link :listLayout="listLayout" :paginationData="filterSet.page" :memberData="List"
                          :ssamsType="ssamsType"></member-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                         :listLength="List.length" :type="memberType" :filterData="filterSet.filter"></pagination-link>
    </div>
</template>

<script>
import MemberFilterLink from "@/components/member/MemberFilterLink";
import MemberListLink from "@/components/member/MemberListLink";
import PaginationLink from "@/components/member/PaginationLink";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import memberUtil from "@/components/member/memberUtil";
import util from "@/mixins/util";
import DeleteClass from "@/mixins/deleteClass";
import EventBus from '../../utils/event-bus';

const {filterConfig} = memberUtil;

export default {
    name: "MemberListComponent",
    mixins: [filterMixins, listMixins, alertMixins, memberUtil],
    components: {MemberFilterLink, MemberListLink, PaginationLink},
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            memberListSetData: this.setData,
            memberListDelete: this.runDeleteConfirm,
            registerStudent: this.registerStudent,
        }
    },
    inject: ['changeLoading'],
    props: {
        memberType: {default: ''},
        ssamsType: {default: ''},
        streamingKey: '',
    },
    data() {
        return {
            listLayout: '',
            filterLayout: '',
            paginationLayout: '',

            getFunc: '',
            listApiParamSet: {},
            pageRow: 10,
            selectArr: [],

            keyName: '',
            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteAlertText: '',
            deleteSuccessAlertText: '',
            DeleteClass: null,
            /*필터 classname*/

            isSetAll: false,
            countryList: [],
            countryOptions: [],
            countryDefaultObj: {
                c_code: "",
                c_idx: "",
                c_is_use: 1,
                c_lang: "전체",
                c_lang_en: "all",
                c_lang_ko: "",
                c_location: "",
                c_name_kr: "전체",
                c_name_us: "all",
                c_number: "",
            },
            langData: [],
        }
    },
    created() {
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
        this.initConfig();
    },
    mounted() {
        this.getList(true);

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let config = this.returnMemberConfig(this.memberType)
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;

            let listOptions = {
                url: this.$api.$member[this.getFunc],
                defaultParams: this.listApiParamSet
            }
            this.initList('api', listOptions);

            this.keyName = config.keyName;
            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.deleteAlertText = config.deleteAlertText
            this.deleteSuccessAlertText = config.deleteSuccessAlertText;

            this.newDeleteClass();
            this.getCountryList();
            this.getLanguageList();
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$member[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }

                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },
        runDeleteConfirm(key) {
            if (util.isEmpty(this.deleteAlertText)) {
                this.runDelete(key);
            } else {
                this.createConfirm({
                    content: this.deleteAlertText,
                    confirm: () => {
                        this.runDelete(key);
                    }
                })
            }
        },
        runDelete(key) {
            this.changeLoading(true);
            this.DeleteClass.runDelete(key);
        },
        deleteAfterFunc() {
            this.getList();
            this.createAlert({
                content: this.deleteSuccessAlertText,
                hide: () => {
                    this.changeLoading(false);
                },
            })
        },
        getCountryList() {
            try {
                this.$api.$config
                    .getCountry()
                    .then((res) => res.Data.Result)
                    .then((res) => {
                        if (res.Info.type != 1) {
                            return false;
                        } else {
                            let list = this.$_.orderBy(res.List, ["c_name_us"], ["asc"]);
                            if (this.isSetAll) {
                                let allWrap = this.countryDefaultObj;
                                list.unshift(allWrap);
                            }
                            this.countryList = list;
                            this.countryOptions = this.countryList;
                        }
                    });
            } catch (e) {
                console.log(e);
            }
        },
        getLanguageList() {
            try {
                this.$api.$config.getLanguage().then(res => res.Data.Result).then(res => {
                    if (res.Info.type != 1 && res.List.length <= 0) {
                        return false
                    } else {
                        this.koreanLangData = res.List.find(item => item.l_idx == 261);
                        this.langData = res.List;
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },

        async registerStudent(key) {
            if(this.isRunning) return false;
            this.changeLoading(true)
            let params = {
                's_idx': this.streamingKey,
            };

            if (key !== 'both') {
                params['mb_no'] = [key];
            } else {
                if (this.selectArr.length === 0) {
                    this.errorAlert('추가할 학생을 선택해주세요.');
                    this.changeLoading(false);
                    return false;
                } else {
                    params['mb_no'] = this.selectArr;
                }
            }
            try {
                this.$api.$streaming[this.deleteFunc](params).then(res => res.Data.Result).then(res => {
                    let status = res.Info.status;
                    if(!status) {
                        if (res.Info.type === -200) {
                            this.errorAlert('이미 등록된 수강생입니다.');
                        } else {
                            this.errorAlert('수강생 등록에 실패했습니다.');
                        }
                        this.changeLoading(false);
                        return ;
                    }
                    EventBus.$emit('newStudent');
                    this.deleteAfterFunc();
                    return;
                })
            }catch (e) {
                this.changeLoading(false);
                return;
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
